module.exports = "/_next/static/images/anonymous-00441bab6412ee298f718b2b880a91cf.png";